import React from 'react'
import { IconProps } from './types'

import { Skeleton } from '@petz/ds-skeleton'
import { BrandConfig } from './enums'

import './index.scss'

export const Icon: React.FC<IconProps> = ({ brand = BrandConfig.Acronym.Petz, skeleton = false, color, name, size, variant, testId, className, ...rest }) => {
  const skeletonSize = {
    'default': 16,
    '4xs': 10,
    '3xs': 12,
    '2xs': 14,
    'xs': 16,
    'sm': 18,
    'md': 20,
    'lg': 24,
    'xl': 28,
    '2xl': 32,
    '3xl': 48,
    'max': 64,
  }

  return skeleton ? (
    <Skeleton width={skeletonSize[size || 'default']} height={skeletonSize[size || 'default']} rounded="max" />
  ) : (
    <i
      data-testid={testId}
      className={`
        ds-icon
        ds-icon-${variant}
        ds-${name}
        ${brand}-icon
        ${size ? `${brand}-icon-${size}` : ''}
        ${color ? `${brand}-icon-${color}` : ''}
        ${className || ''}
      `}
      {...rest}></i>
  )
}
